<template>
  <div class="product-sidebar">
    <div v-if="modelData.images.length > 0" class="product-block product-sidebar-preview d-none d-md-block p-9 blocks--border">
      <img
        @click="openModalSlider"
        :src="modelData.images[0].link_picture"
        :alt="modelData.name_short"
        class="product-sidebar-preview__image"
        :class="{'cursor-pointer': sidebarImageCursorPointer}"
      />
    </div>
    <div class="product-block product-sidebar-buttons-block p-6 d-none d-md-block">
      <!--<div v-if="open.download" class="d-flex flex-column align-center">-->
      <!--  <bim-button @click="open.download = false" color="gray" rounded icon="icon-close-big" icon-size="12" class="mb-6"/>-->
      <!--  <bim-button-->
      <!--    v-if="files.first"-->
      <!--    width="100%"-->
      <!--    size="l"-->
      <!--    :label="'.' + files.first.file_extension.trim().toUpperCase()"-->
      <!--    class="mb-6"-->
      <!--    @click="downloadModel(files.first.id)"-->
      <!--  />-->
      <!--  <bim-button-->
      <!--    v-if="files.second"-->
      <!--    width="100%"-->
      <!--    size="l"-->
      <!--    :label="'.' + files.second.file_extension.trim().toUpperCase()"-->
      <!--    class="mb-6"-->
      <!--    @click="downloadModel(files.second.id)"-->
      <!--  />-->
      <!--  <bim-select-->
      <!--    v-if="files.others && files.others.length"-->
      <!--    class="mb-6"-->
      <!--    width="100%"-->
      <!--    placeholder="Другой формат"-->
      <!--    @change="downloadModel"-->
      <!--    value-name="id"-->
      <!--    label-name="file_extension"-->
      <!--    :options="files.others"-->
      <!--  />-->
      <!--  <p v-if="files.second || files.others.length" class="text-center mb-6">или</p>-->
      <!--  <bim-button v-if="files.second || files.others.length" size="l" width="100%" outline label="Скачать архивом"/>-->
      <!--</div>-->

      <!--<div>-->
        <bim-button
          @click="openDownloadModal"
          width="100%"
          size="l"
          label="Скачать модель"
        />
        <!--<bim-button width="100%" size="l" label="Изменить" color="gray"/>-->
      <!--</div>-->
    </div>
    <div class="product-block product-block--top-radius-none pt-6">
      <div v-if="qrCode && $windowWidth >= 767.9" class="product-sidebar-qr pt-4 pb-9 px-md-6 px-0 blocks--border">

        <bim-text-medium bold tag="p" class="product-sidebar-qr__title">Модель доступна в дополненной реальности</bim-text-medium>
        <div v-html="qrCode" class="qr-code__img"></div>
        <button @click="open.infoArModal = true" class="d-flex mx-auto mb-4 qr-code__btn-info">
          <i class="icon-info"></i>
        </button>
        <p class="qr-code__info">Просканируйте QR-код камерой смартфона.</p>
      </div>

      <!--<div class="ar-mobile" v-if="linkAr && linkAr.length && $windowWidth <= 767.9">-->
      <!--  <div class="posr" v-swiper:mySwiper="swiperOption">-->
      <!--    <div class="swiper-wrapper">-->
      <!--      <div class="swiper-slide" :key="slide.file" v-for="slide in linkAr">-->
      <!--        <div class="ar-block">-->
      <!--          <img src="/dist/assets/front_white/img/svg/ar-mobile.svg" alt="ar icon" class="mb-9">-->
      <!--          <bim-text-medium bold class="mb-9 text-center">Посмотрите продукт в дополненной реальности</bim-text-medium>-->
      <!--          <bim-button @click="openModalArViewMobile(slide.file)" target="_blank" label="Посмотреть в AR" size="l" outline/>-->

      <!--        </div>-->
      <!--      </div>-->
      <!--    </div>-->
      <!--    <bim-button-->
      <!--      v-if="linkAr && linkAr.length > 1"-->
      <!--      text-color="#4d4d4d"-->
      <!--      color="white"-->
      <!--      icon-size="18"-->
      <!--      rounded-->
      <!--      icon="icon-arrow-left22"-->
      <!--      class="slider-arrows slider-arrows&#45;&#45;prev slider-arrows&#45;&#45;ar-models"-->
      <!--    />-->
      <!--    <bim-button-->
      <!--      v-if="linkAr && linkAr.length > 1"-->
      <!--      text-color="#4d4d4d"-->
      <!--      color="white"-->
      <!--      icon-size="18"-->
      <!--      rounded-->
      <!--      icon="icon-arrow-right22"-->
      <!--      class="slider-arrows slider-arrows&#45;&#45;next slider-arrows&#45;&#45;ar-models"-->
      <!--    />-->
      <!--  </div>-->
      <!--  <bim-text-desc bold v-if="linkAr && linkAr.length > 1" class="mt-6">-->
      <!--    <div class="swiper-pagination ar-pagination"></div>-->
      <!--  </bim-text-desc>-->

      <!--</div>-->

      <div class="product-sidebar-company">
        <a
          v-if="authorData.account_type === 'manufacturer' && $windowWidth >= 767.9"
          :href="`/manufacturer/${modelData.alias_organization}/${modelData.id_organization}/?from=single-model`"
          target="_blank"
          class="product-sidebar-company__logo d-flex px-8 py-6 blocks--border"
        >
          <img
            class="product-sidebar-company__logo-img mx-auto"
            :src="modelData.logo.link"
            :alt="modelData.alias_organization"
          />
        </a>

        <component
          :is="$windowWidth >= 767.9 ? 'div' : 'a'"
          :href="$windowWidth >= 767.9 ? '' : `/manufacturer/${modelData.alias_organization}/${modelData.id_organization}/?from=single-model`"
          class="product-sidebar-company__info py-md-9 py-6 px-md-6 px-0 blocks--border"
        >
          <img
            v-if="$windowWidth <= 767.9 && authorData.account_type === 'manufacturer'"
            class="product-sidebar-company__logo-img-mobile"
            :src="modelData.logo.link"
            :alt="modelData.alias_organization"
          />
          <div>
            <bim-text-main bold tag="h3">{{ modelData.name_organization || authorData.administrator_name }}</bim-text-main>
            <span class="product-sidebar-company__register-date">
            На портале с <time>{{authorData.register_data.replace( /(\d{2})-(\d{2})-(\d{4})/, '$2/$1/$3') | date('dateShort')}}</time>
          </span>
          </div>
        </component>

        <div class="py-9 px-md-6 px-0 blocks--border d-none d-md-block" :class="{'blocks--border': !isContactsExist}">
          <bim-button @click="open.requestModel = true" width="100%" size="l" label="Запросить модель" outline class=" mx-auto"/>
        </div>

        <div v-if="isContactsExist" class="product-sidebar-company__contacts px-md-6 px-0 pt-8">
          <div v-if="phoneNumber" class="product-sidebar-company__contacts-phone pb-6">
            <bim-text-desc bold tag="h4">Телефон</bim-text-desc>
            <a
              :href="`tel:${$options.filters.linkPhoneFormat(phoneNumber)}`"
              rel="nofollow"
              class="product-sidebar-company__contacts-link link-second"
            >{{ phoneNumber | phoneFormat }}
            </a>
          </div>
          <div v-if="modelData.user.email" class="product-sidebar-company__contacts-email pb-6">
            <bim-text-desc bold tag="h4">Электронный адрес</bim-text-desc>
            <div @click="showEmail=true" v-if="authorData.account_type === 'designer' && !showEmail" class="show-email">Показать</div>
            <div v-else>
              <a
                v-if="modelData.email_organization"
                :href="`mailto:${modelData.email_organization}`"
                rel="nofollow"
                class="product-sidebar-company__contacts-link link-second"
              >{{ modelData.email_organization }}
              </a>
              <a
                v-else
                :href="`mailto:${modelData.user.email}`"
                rel="nofollow"
                class="product-sidebar-company__contacts-link link-second"
              >{{ modelData.user.email }}
              </a>
            </div>
          </div>
          <div v-if="modelData.site_organization" class="product-sidebar-company__contacts-site pb-6">
            <bim-text-desc bold tag="h4">Сайт</bim-text-desc>
            <a
              :href="modelData.site_organization + '?from=bimlib.pro'"
              rel="nofollow"
              target="_blank"
              class="product-sidebar-company__contacts-link link-second"
            >{{ modelData.site_organization | strippedUrl }}
            </a>
          </div>
        </div>
      </div>
    </div>

    <!--Модалка необходима авторизация-->
    <popup width="450px" title="Внимание!" v-model="open.auth">
      <div>
        <bim-text class="mb-6" type="main">Для скачивания модели вам необходимо авторизоваться либо зарегистрироваться на нашем портале</bim-text>
        <bim-button width="100%" label="Авторизоваться / Зарегистрироваться" @click="openLoginPage" />
      </div>
    </popup>

    <!--Модалка скачивания модели-->
    <popup v-model="open.download" title="Выберите форматы для скачивания" width="492px">
      <div v-metric='`MODEL_DOWNLOAD`' v-for="link in modelData.files" :key="link.id" @click="downloadModel(link.id)" class="download-product-link d-flex align-center">
        <bim-text-medium tag="span" class="download-product-link__name">{{link.name | cut}}</bim-text-medium>
        <bim-text-medium tag="span" class="download-product-link__size ml-auto">{{convertToMegabyte(link.file_size)}}</bim-text-medium>
      </div>
    </popup>

    <!--Модалка информации "Как открыть модель"-->
    <popup v-model="open.infoArModal" width="100vw" title="Как открыть AR-модель">
      <div class="d-flex flex-column instructionArModal">
        <img class="instructionArModal__image mb-9 mt-7 mx-auto" src="/dist/assets/front_white/img/ar/ARinstructions.svg" alt="Инструкция">
        <bim-button @click="open.infoArModal = false" size="l" label="Понятно" class="mx-auto"/>
      </div>
    </popup>

    <requestModel
      v-model="open.requestModel"
      :organizationId="authorData.id"
    />

    <!--<popup v-model="open.viewAr" title="AR-модель">-->
    <!--  <model-viewer style="height: 70vh;" autoplay="" id="reveal" preload="" ar="" :src="modelArLink" :ios-src="modelArLink" alt="3d model" camera-controls="" background-color="#e6e6e6" ></model-viewer>-->
    <!--</popup>-->

    <!--Модалка с картинкой модели-->
    <ModalSlider
      v-if="open.modalSlider"
      @close="closeModalSlider"
      :images="modelData.images"
    />
  </div>
</template>

<script>
import bimTextMedium from '@bimlib/components/bimTextMedium'
import bimTextMain from '@bimlib/components/bimTextMain'
import bimTextDesc from '@bimlib/components/bimTextDesc'
import bimText from '@bimlib/components/bimText'

import bimButton from '@bimlib/components/bimButton'
import bimSelect from '@bimlib/components/bimSelect'
import popup from '@bimlib/components/bimPopup'

import requestModel from '@/components/popups/RequestModel'
import downloadMixin from '@/mixins/models/downloadModel.mixin'

import ModalSlider from '@pages/models/SingleModalSlider'

import { directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  contextVue: this,
  name: 'Sidebar',
  components: {
    bimTextMedium,
    bimTextMain,
    bimTextDesc,
    bimButton,
    bimSelect,
    bimText,
    popup,
    requestModel,
    ModalSlider
  },
  directives: {
    swiper: directive,
  },
  props: {
    sliderData: Array
  },
  mixins: [downloadMixin],
  data () {
    return {
      showEmail: false,
      modelArLink: null,
      open: {
        download: false,
        infoArModal: false,
        requestModel: false,
        viewAr: false,
        modalSlider: false
      },
    }
  },
  created() {
    console.log(this.$props)
  },
  computed: {
    phoneNumber() {
      if (!this.modelData) return ''

      const { phone_organization, user } = this.modelData
      return phone_organization || user.phone || ''
    },
    /**
     * Проверка на существование хотя бы одного поля с контактными данными
     * @return {boolean}
     */
    isContactsExist () {
      return !!this.modelData.user.phone || !!this.modelData.user.email || !!this.modelData.site_organization
    },
    /**
     * Проверяет зашёл ли пользователь с iPad
     * @return {boolean}
     */
    isIpad () {
      if ((/\b(iPad)\b/.test(navigator.userAgent)
        && /WebKit/.test(navigator.userAgent)
        && !window.MSStream)
        || (navigator.platform === 'MacIntel'
          && navigator.maxTouchPoints === 5)
      ) {
        return true
      }
    },
    /**
     * Если картинка модели одна и нет AR модели, то при клике на картинку
     * показывать модальное окно
     * @return {boolean}
     */
    sidebarImageCursorPointer() {
      const arModels = this.sliderData.filter(slide => slide.type === "modelAr")
      return this.sliderData.length === 1 && arModels.length === 0;
    }
  },
  methods: {
    openModalArViewMobile (file) {
      this.modelArLink = file
      this.open.viewAr = true
    },
    closeModalSlider() {
      this.open.modalSlider = false
    },
    openModalSlider() {
      if (this.sidebarImageCursorPointer) {
        this.open.modalSlider = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
